import React, { useContext } from 'react'
import { SideberContext } from '../context/SidebarContext'
import { NavLink } from 'react-router-dom';
import { ApiContext } from '../context/ApiContext';

function Settings() {
  const { mySidebarSetting, setMySidebarSetting, myNotification, setMyNotification, ourService, setOurService } = useContext(SideberContext)
  const { data } = useContext(ApiContext)
  // console.log(mySidebarSetting,"sidebar");

  return (
    <>
      {data ? <div className={mySidebarSetting ? 'setting-main-active' : "setting-main-unactive"} onClick={() => setMySidebarSetting(false)}>
        <div className={mySidebarSetting ? "setting-main-inner-active" : "setting-main-inner-unactive"} onClick={(e) => e.stopPropagation()}>
          <ul className='settings-unordered-list'>
            <li className='settings-list-item' onClick={() => { setMySidebarSetting(false); setMyNotification(true); setOurService(true) }}>Our Service</li>
            <li className='settings-list-item' onClick={() => { setMySidebarSetting(false); setMyNotification(true); setOurService(false) }}>About us</li>
            <NavLink to={data.privacy_policy} target="_blank"><li className='settings-list-item' >Privacy Policy</li></NavLink>
          </ul>
        </div>

      </div> : <div>Finding</div>}
    </>
  )
}

export default Settings